import { useNavigate } from 'react-router-dom'
import { MoreHorizontal, Settings2, Trash2, BarChart3 } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface WorkshopMenuProps {
  id: number
  onDelete?: () => void
}

export const WorkshopMenu = ({ id, onDelete }: WorkshopMenuProps) => {
  const navigate = useNavigate()
  const m = useMessages(messages)
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild onClick={(e) => e.preventDefault()}>
        {/* white by design: белая таблетка читается на любой обложке, она не часть темы приложения.
            Прячется до наведения ТОЛЬКО там, где наведение есть (`hover: hover`, мышь): на
            тач-экране она видна всегда — иначе iOS тратит первое касание карточки на
            «наведение» (проявляет троеточие), и курс открывается лишь со второго. */}
        <button
          onClick={(e) => e.stopPropagation()}
          className="flex h-9 items-center justify-center rounded-full bg-white px-3.5 text-[#1b1b20] shadow-sm transition hover:scale-105 hover:bg-white/90 [@media(hover:hover)]:opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100 focus-visible:opacity-100 motion-reduce:hover:scale-100"
          aria-label={m.a11yOpenCourseMenu}
        >
          <MoreHorizontal className="size-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[190px]"
        onClick={(e) => e.stopPropagation()}
      >
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault()
            navigate(`/course-settings/${id}`)
          }}
          className="text-[15px]"
        >
          <Settings2 className="size-[18px] mr-3" />
          {m.settings}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault()
            navigate(`/stats/${id}`)
          }}
          className="text-[15px]"
        >
          <BarChart3 className="size-[18px] mr-3" />
          {m.stats}
        </DropdownMenuItem>
        {onDelete ? (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault()
                onDelete()
              }}
              className="text-[15px] text-destructive focus:text-destructive focus:bg-destructive/10"
            >
              <Trash2 className="size-[18px] mr-3" />
              {m.delete}
            </DropdownMenuItem>
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
